<template>
  <v-container id="fcreate">
    <v-row>
      <v-col>
        <div class="text-h3 mb-2" v-text="'Создать пользователя'" />
      </v-col>
    </v-row>
    <v-row>
      <v-form v-model="valid" ref="form">
        <v-container fluid>
          <v-row>
            <!-- Name -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.name"
                outlined
                label="Имя"
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Phone -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="phone"
                v-mask="'+#(###)###-##-##'"
                value=""
                outlined
                label="Телефон"
                required
                :rules="rules.phone"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Email -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.email"
                outlined
                label="Email"
                required
                :rules="rules.email"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Submit -->
            <v-col cols="12" md="7">
              <v-btn
                class="mb-2"
                block
                color="primary"
                :loading="loading"
                :disabled="loading"
                @click.prevent="submit"
              >
                Создать
              </v-btn>
              <v-btn
                block
                :loading="loading"
                :disabled="loading"
                @click.prevent="$router.push('/clients')"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import rules from '@/mixins/rules'

  export default {
    mixins: [rules],
    data () {
      return {
        data: {
          phone: '',
          email: '',
          name: '',
          status: true,
        },
        phone: '',
        valid: false,
        loading: false,
        snackbar: false,
      }
    },
    methods: {
      async submit () {
        const valid = await this.$refs.form.validate()

        if (valid) {
          this.loading = true

          this.data.phone = this.phone.match(/[0-9]/g).join('')
          this.$store
            .dispatch('clients/createClients', this.data)
            .then((res) => {
              this.loading = false
              if (res.status === 200) {
                this.$router.push('/clients')
              }
            })
            .catch((err) => {
              this.loading = false
              console.log(err)
            })
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>

<style lang="less">
.sf-selections {
  .v-select__selections {
    min-height: 56px !important;
  }
}

form {
  width: 100%;
}
</style>
